import { z } from 'zod'

// ======================== Listing single item ========================

export const MachineSelectOptionSchema = z
  .object({
    id: z.number(),
    code: z.string(),
    group: z.string(),
    capacityPerHour: z.number(),
    runningPrefix: z.string(),
  })
  .transform((data) => {
    return {
      ...data,
      label: data.code,
      value: data.id.toString(),
    }
  })

export type MachineSelectOption = z.infer<typeof MachineSelectOptionSchema>

export const MachineSelectOptionsSchema = z.array(MachineSelectOptionSchema)

export type MachineSelectOptions = z.infer<typeof MachineSelectOptionsSchema>

export type MachineCodeSelectOption = Omit<MachineSelectOption, 'group'>

// ======================== Listing of Grouped item having the same 'group' ========================

export const MachineSelectGroupOptionSchema = z.object({
  group: z.string(),
  items: z.array(
    z.object({
      id: z.number(),
      code: z.string(),
      capacityPerHour: z.number(),
      label: z.string(),
      value: z.string(),
    })
  ),
})

export type MachineSelectGroupOption = z.infer<
  typeof MachineSelectGroupOptionSchema
>

export const MachineSelectGroupOptionsSchema = z.array(
  MachineSelectGroupOptionSchema
)

export type MachineSelectGroupOptions = z.infer<
  typeof MachineSelectGroupOptionsSchema
>
